export type RootState = {
  appName: string
  isLoading: Boolean
  isSearchContent: Boolean
  isShowNavigationBar: Boolean
  isShowUserHeader: Boolean
  isShowSideBarContent: Boolean
  isForceReloadQuestion: Boolean
  currentSkill: object
  currentSpPage: object
  scrollHistory: number
  previousRoute: string
  isRefreshQuestionCount: boolean
}

export default {
  appName: 'GrowthPad',
  isLoading: false,
  isSearchContent: false,
  isShowNavigationBar: false,
  isShowUserHeader: false,
  isShowSideBarContent: false,
  isForceReloadQuestion: false,
  currentSkill: {},
  currentSpPage: {},
  scrollHistory: 0,
  previousRoute: '',
  isRefreshQuestionCount: false
} as RootState
